/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { withFirebase } from "../../../../containers/Firebase";
import queryString from "query-string";
import { withAuthentication } from "../../../../containers/Session";
import { withRouter } from "react-router-dom";
import {
  DashboardTitle,
  FlexContainer,
  DashboardFilter,
  SearchBar,
  DashboardButton,
  SpinLoader,
  MobileMarginContainer,
} from "../../../../assets/fansaves-ui";
import styled from "styled-components/macro";

import { DashboardStats, DashboardHeader } from "../../../../containers/UIKit";
import { isAdmin, isTeam } from "../../../../containers/Session";

import "../../../../scss/base/typography.scss";

import DashboardBusinessCard from "../../../../containers/DashboardBusinessCard";
import moment from "moment";

import useRedemptionsStore from "../../../../stores/redemptionsStore";
import useTeamsStore from "../../../../stores/teamsStore";
import useSponsorsStore from "../../../../stores/sponsorsStore";
import { Pagination } from "../../../../assets/fansaves-ui";

const StyledSponsorsList = styled(FlexContainer)`
  gap: 45px;
  margin: 50px 0;
  .sponsors-list-title {
    justify-content: flex-start;
  }
  .team-sponsor-list-header {
    margin: 0;
  }
  .business-search-bar {
    align-self: start;
  }
  .sponsors-list-container {
    position: relative;
    margin-bottom: 60px;
    .component-dashboard-filter {
      position: absolute;
      top: -30px;
      left: 0;
      z-index: 2;
    }
  }
`;

const SponsorsList = ({ firebase, match, authUser, history }) => {
  const teamId = match.params.team_id;
  const fetchRedemptions = useRedemptionsStore(
    (state) => state.fetchRedemptions
  );
  const redemptionsFromEvents = useRedemptionsStore(
    (state) => state.redemptions
  );

  const fetchRedemptionsByChunks = useRedemptionsStore(
    (state) => state.fetchRedemptionsByChunks
  );
  const isRedemptionsLoading = useRedemptionsStore((state) => state.isLoading);

  const teams = useTeamsStore((state) => state.teams);
  const fetchTeams = useTeamsStore((state) => state.fetchTeams);
  const teamFromStore = useTeamsStore((state) => state.team);
  const fetchTeam = useTeamsStore((state) => state.fetchTeam);

  const sponsorsFromStore = useSponsorsStore((state) => state.sponsors);
  const isSponsorsLoading = useSponsorsStore((state) => state.isLoading);
  const teamSponsorsFromStore = useSponsorsStore((state) => state.teamSponsors);
  const fetchSponsors = useSponsorsStore((state) => state.fetchSponsors);
  const fetchTeamSponsors = useSponsorsStore(
    (state) => state.fetchTeamSponsors
  );

  const [team, setTeam] = useState(null);
  const [sponsors, setSponsors] = useState(null);
  const [paginatedSponsors, setPaginatedSponsors] = useState(null);
  const [activeOffers, setActiveOffers] = useState(null);
  const [redemptions, setRedemptions] = useState(null);
  const [filter, setFilter] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [redemptionsCountMap, setRedemptionsCountMap] = useState(new Map());
  const [contestEntriesCountMap, setContestEntriesCountMap] = useState(
    new Map()
  );

  useEffect(() => {
    if (teamFromStore && teamFromStore[teamId]) {
      setTeam(teamFromStore[teamId]);
    }
  }, [teamFromStore, teamId]);

  useEffect(() => {
    if (!redemptionsFromEvents) {
      if (isAdmin(authUser)) {
        fetchRedemptionsByChunks(firebase);
      } else {
        fetchRedemptions(firebase);
      }
    }
  }, [
    fetchRedemptions,
    firebase,
    authUser,
    fetchRedemptionsByChunks,
    redemptionsFromEvents,
  ]);

  useEffect(() => {
    if (isAdmin(authUser) && !teams) {
      fetchTeams(firebase);
    }
  }, [fetchTeams, firebase, authUser]);

  useEffect(() => {
    if (isAdmin(authUser) && !sponsorsFromStore) {
      fetchSponsors(firebase);
    }
  }, [fetchSponsors, firebase]);

  useEffect(() => {
    if (
      (isTeam(authUser) && !teamSponsorsFromStore) ||
      (teamSponsorsFromStore && !teamSponsorsFromStore[teamId])
    ) {
      fetchTeamSponsors(firebase, teamId);
    }
  }, [fetchTeamSponsors, firebase, teamId]);

  useEffect(() => {
    if (teamId && (!team || team.key !== teamId)) {
      fetchTeam(firebase, teamId);
    }
  }, [fetchTeam, firebase, teamId]);

  useEffect(() => {
    if (!isRedemptionsLoading && redemptionsFromEvents) {
      if (teamId) {
        setRedemptions(
          redemptionsFromEvents.filter(
            (redemption) => redemption.teamID === teamId
          )
        );
      } else {
        setRedemptions(redemptionsFromEvents);
      }
    }
  }, [redemptionsFromEvents, isRedemptionsLoading]);

  useEffect(() => {
    if (isAdmin(authUser)) {
      if (sponsorsFromStore) {
        if (teamId) {
          setSponsors(
            sponsorsFromStore.filter(
              (sponsor) =>
                sponsor.teams && Object.keys(sponsor.teams).includes(teamId)
            )
          );
        } else {
          setSponsors(sponsorsFromStore);
        }
      }
    } else if (isTeam(authUser)) {
      if (teamSponsorsFromStore && teamSponsorsFromStore[teamId]) {
        setSponsors(teamSponsorsFromStore[teamId]);
      }
    }
  }, [sponsorsFromStore, teamSponsorsFromStore]);

  const getFilterAndQueryFromSearch = () => {
    const search = queryString.parse(window.location.search);
    const pageNumber = search.page ? parseInt(search.page) : 1;
    const filter = search.filter ? search.filter : null;
    const query = search.query;
    setPageNumber(pageNumber);

    if (filter) {
      setFilter(filter);
    } else {
      setFilter("Alphabetical");
    }
    if (query) {
      setSearchQuery(query);
    }

    if (pageNumber) {
      setPageNumber(pageNumber);
    }
  };

  const renderLoading = () => {
    return <SpinLoader hideTitle iconSize="20px" />;
  };

  const setUrlQueryFromFilters = () => {
    const { search } = window.location;
    const params = queryString.parse(search);
    if (filter) {
      params.filter = filter;
    }
    if (searchQuery) {
      params.query = searchQuery;
    } else {
      delete params.query;
    }
    if (pageNumber) {
      params.page = pageNumber;
    }
    const newSearch = queryString.stringify(params);
    window.history.pushState({}, "", `?${newSearch}`);
  };

  const updateTotalPages = (list) => {
    const totalPages = Math.ceil(list.length / 20);
    setTotalPages(totalPages);
  };

  const getPaginatedList = (pageNumber, list) => {
    if (!list) {
      return null;
    }

    const start = (pageNumber - 1) * 20;
    const end = start + 20;
    const paginatedList = list.slice(start, end);
    return paginatedList;
  };

  useEffect(() => {
    getFilterAndQueryFromSearch();
  }, []);

  let stats = [
    {
      label: "Total Businesses",
      value: sponsors
        ? sponsors.length > 0
          ? sponsors.length
          : 0
        : renderLoading(),
    },
    {
      label: "Archived Businesses",
      value: sponsors
        ? sponsors.filter((sponsor) => sponsor.archived).length
        : renderLoading(),
    },
    {
      label: "Active Offers",
      value: activeOffers
        ? activeOffers.length > 0
          ? activeOffers.length
          : 0
        : renderLoading(),
    },
    {
      label: "Total Redemptions",
      value: redemptions
        ? redemptions.filter(
            (redemption) => redemption.transactionType === "redemption"
          ).length
        : renderLoading(),
    },
    {
      label: "Total Contest Entries",
      value: redemptions
        ? redemptions.filter(
            (redemption) => redemption.transactionType === "contest"
          ).length
        : renderLoading(),
    },
  ];

  const filterSponsors = () => {
    if (!sponsors) {
      return;
    }
    if (!filter) {
      return;
    }

    let tempSponsors = [...sponsors];

    switch (filter) {
      case "Alphabetical":
        tempSponsors.sort(
          (a, b) =>
            (a.name &&
              a.name.localeCompare(b.name, undefined, { numeric: true })) ||
            /^[0-9]/.test(a.name) - /^[0-9]/.test(b.name)
        );
        break;
      case "NewestToOldest":
        tempSponsors.sort((a, b) => {
          if (!a.createdAt && b.createdAt) return 1;
          else if (!b.createdAt && a.createdAt) return -1;
          return moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf();
        });
        break;
      case "OldestToNewest":
        tempSponsors.sort((a, b) => {
          if (!a.createdAt && b.createdAt) return 1;
          else if (!b.createdAt && a.createdAt) return -1;
          return moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf();
        });
        break;
      default:
        break;
    }
    setPaginatedSponsors(getPaginatedList(pageNumber, tempSponsors));
    updateTotalPages(tempSponsors);
  };

  const handleSearch = () => {
    if (!searchQuery || searchQuery === "") {
      filterSponsors();
      return;
    }
    setPageNumber(1);
    if (sponsors && sponsors.length > 0) {
      const filteredSponsors = sponsors.filter((sponsor) => {
        if (!sponsor.name) {
          return false;
        }
        return sponsor.name.toLowerCase().includes(searchQuery.toLowerCase());
      });

      setPaginatedSponsors(getPaginatedList(pageNumber, filteredSponsors));
      updateTotalPages(filteredSponsors);
    }
  };

  const handleFilterChange = (filter) => {
    setFilter(filter);
    setPageNumber(1);
    setSearchQuery(null);
  };

  const handlePageChange = (pageNumber) => {
    document.getElementsByTagName("body")[0].scrollIntoView();
    setPageNumber(pageNumber);
    filterSponsors();
  };

  const updateCounts = () => {
    const redemptionsCount = new Map();
    const contestEntriesCount = new Map();

    if (!redemptions || !sponsors) {
      return;
    }

    sponsors.forEach((sponsor) => {
      redemptionsCount.set(sponsor.key, 0);
      contestEntriesCount.set(sponsor.key, 0);
    });

    redemptions.forEach((redemption) => {
      if (redemption.transactionType === "redemption") {
        redemptionsCount.set(
          redemption.sponsorID,
          (redemptionsCount.get(redemption.sponsorID) || 0) + 1
        );
      } else if (redemption.transactionType === "contest") {
        contestEntriesCount.set(
          redemption.sponsorID,
          (contestEntriesCount.get(redemption.sponsorID) || 0) + 1
        );
      }
    });

    setRedemptionsCountMap(redemptionsCount);
    setContestEntriesCountMap(contestEntriesCount);
  };

  useEffect(() => {
    if (redemptions) {
      updateCounts();
    }
  }, [redemptions]);

  useEffect(() => {
    if (sponsors) {
      filterSponsors();
      handleSearch();
    }
  }, [sponsors]);

  useEffect(() => {
    handleSearch();
    setUrlQueryFromFilters();
  }, [searchQuery]);

  useEffect(() => {
    filterSponsors();
    setUrlQueryFromFilters();
  }, [pageNumber, filter]);

  const calculateActiveOffers = () => {
    if (sponsors) {
      const offers = sponsors.reduce((acc, sponsor) => {
        if (sponsor.offers) {
          return [...acc, ...sponsor.offers];
        }
        return acc;
      }, []);
      const activeOffers = offers.filter((offer) => offer.active);
      setActiveOffers(activeOffers);
    }
  };

  useEffect(() => {
    if (sponsors) {
      calculateActiveOffers();
    }
  }, [sponsors, sponsorsFromStore]);

  const getTeamsForSponsor = (sponsorId) => {
    if (!teams) return null;
    const teamsForSponsor = teams.filter((team) => {
      if (team.sponsors) {
        return team.sponsors.includes(sponsorId);
      }
      return false;
    });

    return teamsForSponsor;
  };

  return (
    <StyledSponsorsList>
      <FlexContainer
        className="sponsors-list-title"
        direction="horizontal"
        justifyContent="space-between"
        responsive
      >
        <FlexContainer gap="30px" alignItems="flex-start" width="100%">
          {team && (
            <DashboardHeader
              logo={team.logo}
              name={team.name}
              email={team.email}
              profileUrl={team.website}
              hideEl
              className="team-sponsor-list-header"
            />
          )}
          <DashboardTitle
            title="Businesses"
            backButtonPath={`/portal/${
              match.params.team_id
                ? "teams/" + match.params.team_id + "/dashboard"
                : "dashboard"
            }`}
            className="sponsors-list-title"
            justifyContent="flex-start"
          />
          <DashboardButton
            title="Add a Business"
            icon="fa-solid:plus"
            size="medium"
            type="green"
            onClick={(e) => {
              e.preventDefault();
              history.push(`/portal/sponsors/create`);
            }}
            width="220px"
          />
        </FlexContainer>
        <MobileMarginContainer margin="10px">
          <SearchBar
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            placeholder="Search Businesses"
            className="business-search-bar"
          />
        </MobileMarginContainer>
      </FlexContainer>
      <DashboardStats stats={stats} />
      <FlexContainer
        direction="column"
        gap="20px"
        className="sponsors-list-container"
      >
        <DashboardFilter
          type="business"
          className="component-dashboard-filter inter-b2"
          onSelect={handleFilterChange}
          initialFilterOption={filter}
        />
        <FlexContainer
          alignItems="flex-end"
          width="100%"
          className="deal-list-pagination"
        >
          <Pagination
            totalPages={totalPages}
            pageNumber={pageNumber}
            onPageChange={handlePageChange}
            className={totalPages > 1 ? "" : "hide"}
          />
        </FlexContainer>
        {isSponsorsLoading ? (
          <div className="no-organizations">
            <SpinLoader />
          </div>
        ) : (
          <>
            {paginatedSponsors && paginatedSponsors.length > 0 ? (
              paginatedSponsors.map((sponsor, index) => (
                <div key={sponsor.key + sponsor.name} style={{ width: "100%" }}>
                  <DashboardBusinessCard
                    key={sponsor.key + sponsor.name}
                    business={sponsor}
                    renderButtonsGroup
                    redemptionsCount={redemptionsCountMap.get(sponsor.key || 0)}
                    contestEntriesCount={contestEntriesCountMap.get(
                      sponsor.key || 0
                    )}
                    showRedemptionsTitle
                    teamsForLogo={getTeamsForSponsor(sponsor.key)}
                  />
                </div>
              ))
            ) : (
              <div className="no-organizations">
                <p>No businesses found</p>
              </div>
            )}
          </>
        )}
        <FlexContainer
          alignItems="flex-end"
          width="100%"
          className="deal-list-pagination"
          padding="0 0 30px 0"
        >
          <Pagination
            totalPages={totalPages}
            pageNumber={pageNumber}
            onPageChange={handlePageChange}
            className={totalPages > 1 ? "" : "hide"}
            marginBottom="50px"
          />
        </FlexContainer>
      </FlexContainer>
    </StyledSponsorsList>
  );
};

export default withFirebase(withAuthentication(withRouter(SponsorsList)));
